import { render, staticRenderFns } from "./PricesManagement.vue?vue&type=template&id=83feacf8"
import script from "./PricesManagement.vue?vue&type=script&lang=js"
export * from "./PricesManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports